import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';

const OrderConfirmation = () => {
  const location = useLocation();
  const { orderId, email } = location.state || {};

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0D0D0D',
      fontFamily: "'TASA Orbiter Display', sans-serif",
      display: 'flex',
      flexDirection: 'column',
    }}>
      <Helmet>
        <title>Order Confirmed | RTK</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      {/* Header */}
      <header style={{
        height: '70px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: '1px solid #1C1C1C',
      }}>
        <Link to="/">
          <img
            src="/logo.png"
            alt="Logo"
            style={{ height: '40px', width: 'auto' }}
          />
        </Link>
      </header>

      {/* Main Content */}
      <main style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        textAlign: 'center',
      }}>
        {/* Success Icon */}
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          backgroundColor: '#1C1C1C',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '32px',
        }}>
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#4CAF50"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        {/* Thank You Message */}
        <h1 style={{
          fontSize: '28px',
          fontWeight: '400',
          color: '#F1F1F1',
          marginBottom: '16px',
        }}>
          Thank you for your order!
        </h1>

        <p style={{
          fontSize: '14px',
          color: '#8A8A8A',
          marginBottom: '8px',
          maxWidth: '400px',
        }}>
          Your payment was successful. We've sent a confirmation email to:
        </p>

        {email && (
          <p style={{
            fontSize: '14px',
            color: '#F1F1F1',
            marginBottom: '24px',
          }}>
            {email}
          </p>
        )}

        {orderId && (
          <div style={{
            padding: '16px 24px',
            backgroundColor: '#1C1C1C',
            borderRadius: '4px',
            marginBottom: '32px',
          }}>
            <p style={{
              fontSize: '12px',
              color: '#8A8A8A',
              marginBottom: '4px',
            }}>
              Order ID
            </p>
            <p style={{
              fontSize: '14px',
              color: '#F1F1F1',
              fontFamily: 'monospace',
            }}>
              {orderId}
            </p>
          </div>
        )}

        <p style={{
          fontSize: '13px',
          color: '#6F6F6F',
          marginBottom: '32px',
          maxWidth: '400px',
        }}>
          You will receive shipping updates via email once your order has been dispatched.
        </p>

        {/* Continue Shopping Button */}
        <Link
          to="/collection"
          style={{
            padding: '14px 32px',
            backgroundColor: '#F1F1F1',
            color: '#0D0D0D',
            textDecoration: 'none',
            fontSize: '14px',
            borderRadius: '4px',
            transition: 'opacity 0.2s ease',
          }}
          onMouseEnter={(e) => e.target.style.opacity = '0.9'}
          onMouseLeave={(e) => e.target.style.opacity = '1'}
        >
          Continue Shopping
        </Link>
      </main>

      {/* Footer */}
      <footer style={{
        padding: '24px',
        borderTop: '1px solid #1C1C1C',
        textAlign: 'center',
      }}>
        <p style={{
          fontSize: '12px',
          color: '#6F6F6F',
        }}>
          Questions about your order?{' '}
          <Link
            to="/contact"
            style={{
              color: '#F1F1F1',
              textDecoration: 'none',
            }}
          >
            Contact us
          </Link>
        </p>
      </footer>
    </div>
  );
};

export default OrderConfirmation;